import React from 'react';
import SiteHeader from '../../components/SiteHeader';
import SiteFooter from '../../components/SiteFooter';
import GolfHero from '../../components/golf/GolfHero';
import GolfPresentation from '../../components/golf/GolfPresentation';
import GolfParcours from '../../components/golf/GolfParcours';
import GolfMasterPlan from '../../components/golf/GolfMasterPlan';
import GolfEquipements from '../../components/golf/GolfEquipements';
import GolfLifestyle from '../../components/golf/GolfLifestyle';
import GolfAccessibilite from '../../components/golf/GolfAccessibilite';
import GolfContact from '../../components/golf/GolfContact';

const GolfHomePage = () => {
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <SiteHeader />
      <main>
        <GolfHero />
        <GolfPresentation />
        <GolfMasterPlan />
        <GolfParcours />
        <GolfEquipements />
        <GolfLifestyle />
        <GolfAccessibilite />
        <GolfContact />
      </main>
      <SiteFooter />
    </div>
  );
};

export default GolfHomePage;
